module.exports = __webpack_public_path__ + "img/box3_img4_dark.8cf8ad49.png";